import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 4v16","key":"svg-0"}],["path",{"d":"M17 4v16","key":"svg-1"}],["path",{"d":"M19 4h-9.5a4.5 4.5 0 0 0 0 9h3.5","key":"svg-2"}]]

/**
 * IconPilcrow
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGlsY3JvdyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTMgNHYxNiIgLz4KICA8cGF0aCBkPSJNMTcgNHYxNiIgLz4KICA8cGF0aCBkPSJNMTkgNGgtOS41YTQuNSA0LjUgMCAwIDAgMCA5aDMuNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/pilcrow
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPilcrow = createReactComponent('outline', 'pilcrow', 'Pilcrow', __iconNode);

export default IconPilcrow;